/**
 * @generated SignedSource<<4784230a023440affc8ad268a05c098f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MisconfiguredStripeObjectAction = "make_free" | "recreate" | "reset" | "unarchive" | "%future added value";
export type MisconfiguredStripeObjectType = "price_archived" | "price_changed" | "price_deleted" | "product_archived" | "product_deleted" | "%future added value";
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
export type MisconfiguredStripeObjectModalContentQuery$variables = {
  id: string;
};
export type MisconfiguredStripeObjectModalContentQuery$data = {
  readonly record: {
    readonly actions?: ReadonlyArray<{
      readonly action: MisconfiguredStripeObjectAction;
      readonly available: boolean;
      readonly reason: string | null;
    }>;
    readonly id?: string;
    readonly pricing?: {
      readonly " $fragmentSpreads": FragmentRefs<"pricingUtils_usePricingDisplayValue">;
    } | null;
    readonly product?: {
      readonly type: ProductType;
    } | null;
    readonly type?: MisconfiguredStripeObjectType;
  } | null;
};
export type MisconfiguredStripeObjectModalContentQuery = {
  response: MisconfiguredStripeObjectModalContentQuery$data;
  variables: MisconfiguredStripeObjectModalContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AvailableAction",
  "kind": "LinkedField",
  "name": "actions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "action",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "available",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MisconfiguredStripeObjectModalContentQuery",
    "selections": [
      {
        "alias": "record",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Pricing",
                "kind": "LinkedField",
                "name": "pricing",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "pricingUtils_usePricingDisplayValue"
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "type": "MisconfiguredStripeObject",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MisconfiguredStripeObjectModalContentQuery",
    "selections": [
      {
        "alias": "record",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Pricing",
                "kind": "LinkedField",
                "name": "pricing",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frequency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountCents",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "type": "MisconfiguredStripeObject",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eaea8e924e1fd98c5ce73240c505568f",
    "id": null,
    "metadata": {},
    "name": "MisconfiguredStripeObjectModalContentQuery",
    "operationKind": "query",
    "text": "query MisconfiguredStripeObjectModalContentQuery(\n  $id: ID!\n) {\n  record: node(id: $id) {\n    __typename\n    ... on MisconfiguredStripeObject {\n      id\n      type\n      product {\n        type\n        id\n      }\n      pricing {\n        ...pricingUtils_usePricingDisplayValue\n        id\n      }\n      actions {\n        action\n        available\n        reason\n      }\n    }\n    id\n  }\n}\n\nfragment pricingUtils_usePricingDisplayValue on Pricing {\n  frequency\n  kind\n  amountCents\n}\n"
  }
};
})();

(node as any).hash = "9f56752a547d216901ba54d866add4b7";

export default node;
